/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderReject
 */
export interface OrderReject {
    /**
     * 
     * @type {string}
     * @memberof OrderReject
     */
    reason: string;
}

/**
 * Check if a given object implements the OrderReject interface.
 */
// @ts-ignore
export function instanceOfOrderReject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

// @ts-ignore
export function OrderRejectFromJSON(json: any): OrderReject {
    return OrderRejectFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderRejectFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderReject {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

// @ts-ignore
export function OrderRejectToJSON(value?: OrderReject | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason': value.reason,
    };
}

